import { message } from "antd";
import { checkAuthorization } from "../../helpers";
import { domainUrl } from "../../constants";

const DataEntryRegister = (data) => {
    const {userToken} = checkAuthorization()
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append('Authorization', userToken);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
    };

    return(
        fetch(domainUrl + '/dataEntryRegister', requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success(result?.message);
                return 1
            } 
            else 
                throw result?.message
            
        })
        .catch(error => {
            message.error(error.message || 'Something went wrong');
            return 0 
        })
    )
};

const dataentry = {
    DataEntryRegister
}

export { dataentry }